/**
 * Utility functions for currency formatting
 */

/**
 * Safely formats a number as currency with proper fallbacks
 * @param amount - The amount to format (can be number, string, null, or undefined)
 * @param currency - The currency symbol (default: 'R')
 * @param decimals - Number of decimal places (default: 2)
 * @returns Formatted currency string
 */
export function formatCurrency(
  amount: number | string | null | undefined,
  currency: string = 'R',
  decimals: number = 2
): string {
  if (amount === null || amount === undefined || amount === '') {
    return `${currency} 0.${'0'.repeat(decimals)}`;
  }
  
  const numAmount = Number(amount);
  
  if (isNaN(numAmount)) {
    return `${currency} 0.${'0'.repeat(decimals)}`;
  }
  
  return `${currency} ${numAmount.toFixed(decimals)}`;
}

/**
 * Safely formats a number with decimal places
 * @param amount - The amount to format
 * @param decimals - Number of decimal places (default: 2)
 * @returns Formatted number string
 */
export function formatNumber(
  amount: number | string | null | undefined,
  decimals: number = 2
): string {
  if (amount === null || amount === undefined || amount === '') {
    return `0.${'0'.repeat(decimals)}`;
  }
  
  const numAmount = Number(amount);
  
  if (isNaN(numAmount)) {
    return `0.${'0'.repeat(decimals)}`;
  }
  
  return numAmount.toFixed(decimals);
}
